// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import Vuex from 'vuex'
import App from './App'
import router from './router'
import iview from 'view-design'
import mStore from '@/common/store.js'
// import style
import 'view-design/dist/styles/iview.css';
// import iEditor from 'iview-editor'; //引入编辑器
// import 'iview-editor/dist/iview-editor.css'; //引入编辑器样式
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
Vue.config.productionTip = false
Vue.use(iview)
// Vue.use(Vuex)
Vue.use(mavonEditor)
Vue.prototype.mStore = mStore
// Vue.use(iEditor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js